export const GROWTH_FACTORS_LINK =
    'https://help.alvalabs.io/en/articles/4410402-alva-s-growth-factors';
export const DRIVERS_LINK =
    'https://help.alvalabs.io/en/articles/4449867-growth-factors-drivers';
export const CULTURE_PREFERENCES_LINK =
    'https://help.alvalabs.io/en/articles/4449997-growth-factors-culture-preferences';
